import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionMailingInformation } from 'app/models/convention-mailing-information.model';
import { LOVConventionGenderExtension } from 'app/models/extensions/lov-convention-gender-extension.model';
import { LinkGenderConvention } from 'app/models/link-gender-convention.model';
import { MRMValidators } from '@mrm/core';

export class LOVConventionGender extends LOVConventionGenderExtension {
  conventionGenderDBID: number = 0;
  legacyCode: string = null;
  englishDescription: string = null;
  frenchDescription: string = null;
  isActive?: boolean = null;
  orderNumber: number = 0;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionMailingInformations: ConventionMailingInformation[] = [];
  linkGenderConventions: LinkGenderConvention[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      conventionGenderDBID: new FormControl({ value: 0, disabled: disableAll }),
      legacyCode: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(2)]),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionMailingInformations: new FormArray([]),
      linkGenderConventions: new FormArray([])
    });


    return form;
  }
}